const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_app/$lang/$family/$slug/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_app/$lang/$family/$slug/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { buildFeaturePageHead } from "@/features/feature-page/feature-page-head";
import { parseArtistDirectorySearch } from "@/features/feature-page/parseArtistDirectorySearch";
export const Route = createFileRoute("/_app/$lang/$family/$slug/")({
  validateSearch: parseArtistDirectorySearch,
  // Directory filters are driven by React Query inside the page. Keeping them
  // out of loaderDeps avoids replacing the page with route pending state for
  // each client-side filter change.
  loaderDeps: () => ({}),
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: ({
    loaderData,
    match
  }) => buildFeaturePageHead(loaderData?.page, {
    hasDirectoryVariants: Object.values(match.search as ArtistDirectorySearchState).some(value => value !== undefined)
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});